import { useEffect, useState, useRef } from "react";
import { commonUrl, idMapTopic, basePath } from '../api/config';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Head from 'next/head';
import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Footer from "../../components/Footer";
import SubHeader from '../../components/SubHeader';
import Spinner from '../../components/Spinner';
import styles from '../../styles/ListView.module.css';
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import DatePicker from "./datePicker";
import * as LIB from '../../lib/common';
import { filterProtectedContent, useLoginStatus } from '../../lib/protectedContent';
import Listing from "./listing";
import MusicListing from "./musicListing";
import MusicTab from "./musicTab";
import Feeding from "./feeding";
import PlayList from "./playlist";
import Player from "../../components/Player";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faList, faGripVertical } from '@fortawesome/free-solid-svg-icons';

const ListView = ({ topicID, tag }) => {
    //define state
    const [typeName, setTypeName] = useState('···');
    const [listData, setListData] = useState([]);
    const [nextPageUrl, setUrl] = useState('');
    const [availableDates, setDates] = useState([]);
    const [curMonth, setCurMonth] = useState('');
    const [modalShow, setModalShow] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [topicList, setTopicList] = useState([]);
    const [forceListing, setForceListing] = useState(false);
    const [musicTabID, setMusicTabID] = useState('01f,01c,01d,01g,01h');
    const [isLoading, setIsLoading] = useState(true);
    const [dateFiltered, setDateFiltered] = useState(false); //control the article open method: _blank | _self
    const trashIcon = <FontAwesomeIcon icon={faTrashAlt} />;
    const feedingIconOn = <FontAwesomeIcon icon={faList} className={styles.switchIconOn} />;
    const feedingIconOff = <FontAwesomeIcon icon={faList} className={styles.switchIconOff} />;
    const gridIconOn = <FontAwesomeIcon icon={faGripVertical} className={styles.switchIconOn} />;
    const gridIconOff = <FontAwesomeIcon icon={faGripVertical} className={styles.switchIconOff} />;
    const playerRef = useRef();
    const [isLoggedIn] = useLoginStatus();
    const visibleList = filterProtectedContent(listData, isLoggedIn);

    useEffect(() => {
        //called if topic id changed
        if (topicID != 0 && topicID.length == 3) {
            setListData([]);
            setUrl();
            fetchInitData(topicID);
        }
    }, [topicID]);

    const fetchInitData = async (id) => {
        let url = "";

        if (id == 'pmt') {
            url = commonUrl.promotion + '?list=true';
        }
        else if (id == 'blo') {
            url = commonUrl.blog;
        }
        else if (id == 'btm') {
            url = commonUrl.bttm;
        }
        else if (id == 'vid') {
            url = commonUrl.video + '?list=true';
        }
        else if (id == 'mus') {
            url = `${basePath}/zd30_api_topic/${musicTabID}`;
        }
        else {
            url = `${basePath}/zd30_api_topic/${id}` + (tag ? '?tag=' + tag : '');
        }

        const res = await fetch(url, { method: 'GET' });
        const postData = await res.json();
        
        if (postData) {
            //set data
            setListData(postData.data);
            setDates(postData.dates);
            let nextPage = res.headers.get('x-next-page-url');
            if (nextPage != '') {
                setUrl(nextPage);
            } else {
                setHasMore(false);
            }
        }

        setIsLoading(false);
    };

    const fetchMoreData = async () => {
        let url = basePath + nextPageUrl;
        // console.log('load more data url=', url);
        if (nextPageUrl == '') return;
        const res = await fetch(url, { method: 'GET' });
        const postData = await res.json();

        if (postData.data.length > 0) {
            setListData([...listData, ...postData.data]);
            //get the load more url from header
            let nextPage = res.headers.get('x-next-page-url');
            if (nextPage != '') {
                setUrl(nextPage);
            } else {
                setHasMore(false);
            }
        } else {
            //no more data
            setHasMore(false);
        }

        setIsLoading(false);
    };

    const handleTopicList = (data) => {
        //map data to name list
        setTopicList(data);
        let exception = ['pmt', 'blo', 'mus', 'btm', 'vid'];
        if (exception.includes(topicID)) {
            setTypeName(idMapTopic[topicID].topic);
        } else {
            setTypeName(data[topicID]);
        }
    }

    //Date picker
    const handleDateSelect = async (value) => {
        if (value) {
            //hide the picker
            setModalShow(false);
            setCurMonth(value);
            setDateFiltered(true);

            //construct the next page url with selected date
            let urlWithDate = '';
            if (nextPageUrl && nextPageUrl != '') {
                let path = _.split(nextPageUrl, '/', 4);
                //console.log('path=', path);
                if (path[1] == 'zd30_api_latest_video' || path[1] == 'zd30_api_news') {
                    //news or video , e.g /zd30_api_latest_video/2021-09
                    urlWithDate = `/${path[1]}/${value}`;
                } else {
                    urlWithDate = `/${path[1]}/${path[2]}/${path[3]}/${value}`;
                }
            } else {
                //if no nextpage url from header
                let path = LIB.getUrlParams();
                urlWithDate = `/zd30_api_topic/${path[3]}/${path[3]}/${value}`;
            }

            if (urlWithDate) {
                let url = basePath + urlWithDate + (tag ? '?tag=' + tag : '');
                //console.log('url to load data by month=', url);

                const res = await fetch(url, { method: 'GET' });
                const postData = await res.json();

                if (postData) {
                    setListData([]);
                    setListData(postData.data);

                    //for catch the next page url for first time only
                    let nextPage = res.headers.get('x-next-page-url');
                    if (nextPage) {
                        setUrl(nextPage);
                    }

                    //prevent to load more data
                    setHasMore(false);
                }
            }
        }
    }

    const removeTagFilter = () => {
        window.location.href = window.location.href.replace(/\?tag=.*/, '');
    }

    const removeFilter = () => {
        //remove filter button action:
        setCurMonth('');
        setListData([]);
        setHasMore(true);
        setDateFiltered(false);

        if (topicID == 'mus') {
            fetchInitData(musicTabID);
        } else {
            fetchInitData(topicID);
        }
    }

    const renderFilter = () => {
        if (availableDates && availableDates.length > 0) {
            return (
                <Container fluid style={{ padding: 0 }}>
                    <Row style={{ margin: 0 }}>
                        <Col lg={12} className={styles.filterCol}>
                            <div className={styles.filterHolder}>
                                <div className={styles.filterHeader}>篩選：</div>
                                {
                                    tag && <div className={styles.tagFilterBtn} onClick={() => removeTagFilter()}>{decodeURIComponent(tag)}</div>
                                }
                                <div className={styles.datePickerBtn} onClick={() => setModalShow(true)}>{curMonth != '' ? curMonth : '選擇月份'}</div>
                                {curMonth && <div className={styles.removeFilter} onClick={() => { removeFilter() }}>{trashIcon}</div>}
                                {renderSwitch()}
                            </div>
                            <DatePicker
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                                data={availableDates}
                                selectmonth={(value) => handleDateSelect(value)}
                                currentmonth={curMonth}
                            />
                        </Col>
                    </Row>
                </Container>
            );
        }
    }

    const switchListing = () => {
        setForceListing(!forceListing);
    }

    const renderSwitch = () => {
        if (topicID == '03d') {
            return (
                <>
                    <div className={styles.forceListing} onClick={() => { switchListing() }}>
                        {forceListing ? gridIconOn : gridIconOff}
                    </div>
                    <div className={styles.forceListing} onClick={() => { switchListing() }}>
                        {forceListing ? feedingIconOff : feedingIconOn}
                    </div>
                    <div className={styles.readingMode}>閱讀模式：</div>
                </>
            );
        }
    }

    const switchMusicTab = (tabID) => {
        setMusicTabID(tabID)
        setCurMonth('');
        setListData([]);
        setHasMore(true);
        setIsLoading(true);
        fetchInitData(tabID);
    }

    const loading = (
        <Spinner/>
    );

    const renderContent = () => {
        if (topicID == '03d' && !forceListing) {
            return (<Feeding listData={visibleList} typeName={typeName} typeID={topicID} />);
        } else if (topicID == 'mus') {
            return (<MusicListing listData={visibleList} typeName={typeName} typeID={musicTabID} />);
        } else {
            return (<Listing listData={visibleList} typeName={typeName} typeID={topicID} dateFiltered={dateFiltered} />)
        }
    }

    /////////////////////////////////////////////////////
    // render 音樂特輯 listview
    /////////////////////////////////////////////////////
    if (topicID == 'mus') {
        return (
            <Layout>
                <Head>
                    <title>{typeName} | 錫安日報</title>
                    <link rel="icon" type="image/x-icon" href="/favicon.ico" />
                </Head>
                <Header getTopicData={handleTopicList} />
                <SubHeader data={typeName} />
                <div className={styles.listHolder}>
                    <div className="viewport">
                        {renderFilter()}
                        <Container fluid style={{ padding: 0 }}>
                            <Row style={{ padding: 0, margin: 0 }}>
                                <PlayList size='sm' />
                                <Col lg={9} md={8} className={styles.col}>
                                    <InfiniteScroll
                                        dataLength={listData.length}
                                        next={fetchMoreData}
                                        loader={loading}
                                        hasMore={hasMore}
                                        endMessage={
                                            <p style={{ textAlign: "center" }}>
                                                <div className={styles.endOfCentent}>以上已是全部內容</div>
                                            </p>
                                        }
                                    >
                                        <MusicTab switchTab={switchMusicTab} tabID={musicTabID} topics={topicList} />
                                        {isLoading === true ? loading : <></>}
                                        <MusicListing listData={visibleList} typeName={typeName} typeID={topicID} />
                                    </InfiniteScroll>
                                </Col>
                                <PlayList size='lg' />
                            </Row>
                        </Container>
                    </div>
                </div>
                <Footer />
            </Layout>
        );
    }
    /////////////////////////////////////////////////////
    // render 一般 listview
    /////////////////////////////////////////////////////
    else if (topicID) {
        return (
            <Layout>
                <Head >
                    <title>{typeName} | 錫安日報</title>
                    <link rel="icon" type="image/x-icon" href="/favicon.ico" />
                </Head>
                <Header getTopicData={handleTopicList} />
                <SubHeader data={typeName} />
                <div className={styles.listHolder}>
                    <div className="viewport">
                        {renderFilter()}
                        <InfiniteScroll
                            dataLength={listData.length}
                            next={fetchMoreData}
                            loader={loading}
                            hasMore={hasMore}
                            endMessage={
                                <p style={{ textAlign: "center" }}>
                                    <div className={styles.endOfCentent}>以上已是全部內容</div>
                                </p>
                            }
                            style={{ overflow: 'visible' }}
                        >
                            {renderContent()}
                        </InfiniteScroll>
                    </div>
                </div>
                {
                    //for feeding page, bg music
                    topicID == '03d' && !forceListing ?
                        <Player ref={playerRef} source={commonUrl.feedingBgMusic} autoStart={true} lessControl={true} /> :
                        <></>
                }
                <Footer />
            </Layout>
        );
    } else {
        return (<></>);
    }

}

export default ListView;